import React from "react";
import { NavBar } from "./navigation/desktop/nav-bar";
import { MobileNavBar } from "./navigation/mobile/mobile-nav-bar";
import { PageFooter } from "./page-footer";

interface Props {
  children: JSX.Element;
  className?: string; // Optional className prop
  fullWidth?: boolean; // Optional prop for full-width layout
}

export const PageLayout: React.FC<Props> = ({ children, className = "", fullWidth = false }) => {
  const contentClass = fullWidth ? "page-layout__content--full-width" : "page-layout__content";
  
  return (
    <div className={`page-layout ${className}`}>
      <NavBar />
      <MobileNavBar />
      <div className={contentClass}>{children}</div>
      <PageFooter />
    </div>
  );
};